import { Deserializable } from '../protocols/deserializable';

export class InvestmentInstructionSubmissionAffectedAccount implements Deserializable {
  public accountId!: number;
  public employerName!: string;
  public totalBalance!: number;

  public onDeserialize() {}
}
